// extracted by mini-css-extract-plugin
export default {"container":"Failed_container__uj9nf"};